// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function hoverAnimation(interactive) {
  if (interactive) {
    return "transform transition-all duration-200 ease-out cursor-pointer hover:scale-105 hover:shadow-lg hover:border-pigmentblue";
  } else {
    return "cursor-not-allowed opacity-90";
  }
}

function compactSectionClass(enforced) {
  return "group relative rounded-xl border border-gray-200 bg-white overflow-hidden min-w-0 " + (
          enforced ? "cursor-not-allowed opacity-90" : "transform transition-all duration-200 ease-out cursor-pointer hover:scale-105 hover:shadow-lg hover:border-pigmentblue"
        );
}

function compactCardClass(enforced, enabled) {
  var stateClass = enabled !== undefined ? (
      enabled ? "border-l-4 border-l-americangreen border border-pigmentblue bg-lavenderweb shadow-sm" : "border-l-4 border-l-gray-300 border border-gray-200 bg-ghostwhitegray"
    ) : "border border-gray-200 bg-white";
  return "group relative rounded-xl p-4 " + stateClass + " " + (
          enforced ? "cursor-not-allowed opacity-90" : "transform transition-all duration-200 ease-out cursor-pointer hover:scale-105 hover:shadow-lg hover:border-pigmentblue"
        );
}

function compactChannelCardClass(enforced, enabled) {
  var stateClass = enabled ? "border-l-4 border-l-americangreen border border-pigmentblue bg-lavenderweb shadow-sm" : "border-l-4 border-l-gray-300 border border-gray-200 bg-ghostwhitegray";
  return "group relative rounded-lg p-3 " + stateClass + " " + (
          enforced ? "cursor-not-allowed opacity-90" : "transform transition-all duration-200 ease-out cursor-pointer hover:scale-105 hover:shadow-lg hover:border-pigmentblue"
        );
}

function titleClass(enabled) {
  if (enabled !== undefined) {
    if (enabled) {
      return "text-sm font-semibold text-pigmentblue";
    } else {
      return "text-sm font-semibold text-aurometalsaurus";
    }
  } else {
    return "text-sm font-semibold text-darkcharcoal";
  }
}

function descriptionClass(enabled) {
  if (enabled !== undefined) {
    if (enabled) {
      return "text-xs mt-1 leading-relaxed text-darkcharcoal";
    } else {
      return "text-xs mt-1 leading-relaxed text-gray-400";
    }
  } else {
    return "text-xs mt-1 leading-relaxed text-aurometalsaurus";
  }
}

function ConfigurationSettingCard$statusBadge(props) {
  if (props.enabled) {
    return JsxRuntime.jsxs("span", {
                children: [
                  JsxRuntime.jsx("span", {
                        className: "h-1.5 w-1.5 rounded-full bg-americangreen"
                      }),
                  "Enabled"
                ],
                className: "inline-flex items-center gap-1 px-1.5 py-0.5 text-xs font-medium text-americangreen bg-green-50 border border-green-200 rounded-full"
              });
  } else {
    return JsxRuntime.jsxs("span", {
                children: [
                  JsxRuntime.jsx("span", {
                        className: "h-1.5 w-1.5 rounded-full bg-gray-400"
                      }),
                  "Disabled"
                ],
                className: "inline-flex items-center gap-1 px-1.5 py-0.5 text-xs font-medium text-aurometalsaurus bg-gray-100 border border-gray-200 rounded-full"
              });
  }
}

var statusBadge = ConfigurationSettingCard$statusBadge;

exports.hoverAnimation = hoverAnimation;
exports.compactSectionClass = compactSectionClass;
exports.compactCardClass = compactCardClass;
exports.compactChannelCardClass = compactChannelCardClass;
exports.titleClass = titleClass;
exports.descriptionClass = descriptionClass;
exports.statusBadge = statusBadge;
/* react/jsx-runtime Not a pure module */
